<template>
  <div>
    <v-container class="lighten-5">
      <v-row>
        <v-col>
          <v-img v-if="invoice.logo" :src="invoice.logo" max-height="100" max-width="100"></v-img>
          <div style="white-space:pre;">
            <h2>{{invoice.from.name}}</h2>
            <p>{{invoice.from.address}}</p>
            <p>{{invoice.from.details}}</p>
            <p>{{invoice.from.email}}</p>
          </div>
        </v-col>
        <v-col>
          <h2>{{invoice.type}}</h2>
          <p>
            <b>Nº</b>
            :{{invoice.number}}
          </p>
          <p>
            <b>Date</b>
            : {{invoice.date}}
          </p>
          <p v-if="invoice.have_due_date">
            <b>{{$t('app.due_date')}}</b>
            : {{invoice.dueDate}}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h3>{{$t('app.bill_to')}}</h3>
          <h2>{{invoice.to.name}}</h2>
          <p>{{invoice.to.address}}</p>
          <p>{{invoice.to.details}}</p>
          <p>{{invoice.to.email}}</p>
        </v-col>
        <v-col></v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Ref</th>
                  <th class="text-left">{{$t('app.description')}}</th>
                  <th class="text-left">{{$t('app.price')}}</th>
                  <th class="text-left">{{$t('app.quantity')}}</th>
                  <th class="text-left">{{$t('app.sub_total')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in invoice.items" :key="item.name">
                  <td>{{ item.ref }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.price }}</td>
                  <td>{{ item.qty }}</td>
                  <td>{{ item.qty * item.price }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col></v-col>
        <v-col>
          <v-simple-table>
            <template v-slot:default>
              <thead></thead>
              <tbody>
                <tr>
                  <th class="text-left">{{$t('app.sub_total')}}</th>

                  <td>
                    {{ getSubTotal() }}
                    <small>{{invoice.currency}}</small>
                  </td>
                </tr>
                <tr v-bind:key="tax.name" v-for="tax in invoice.taxes">
                  <th class="text-left">{{ tax.name }}</th>
                  <td>
                    {{ tax.amount }}
                    <small>{{ tax.type === 'rate' ? '%' : invoice.currency }}</small>
                  </td>
                </tr>
                <tr>
                  <th class="text-left">{{$t('app.total_tax')}}</th>
                  <td>
                    {{ getTotalTaxes() }}
                    <small>{{invoice.currency}}</small>
                  </td>
                </tr>
                <tr>
                  <th class="text-left">{{$t('app.total')}}</th>
                  <td>
                    {{ getTotal() }}
                    <small>{{invoice.currency}}</small>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-snackbar v-model="snack" :timeout="3000">
        {{ snackText }}
        <v-btn text @click="snack = false">{{$t('app.close')}}</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
export default {
  name: "InvoicePreview",
  components: {},
  data() {
    return {
      snack: true,
      snackText: "Press CTRL+P to print the invoice !"
    };
  },
  computed: {
    ...mapState(["invoice", "user"])
  },
  created() {},
  mounted() {
    this.toogleNavbarAction();

    if (firebase.auth().currentUser == null) {
      firebase
        .auth()
        .signInAnonymously()
        .then(r => console.log(r));
    }
  },
  methods: {
    ...mapActions([
      "toogleNavbarAction",
      "updateModal",
      "updateSubTotal",
      "updateTotal"
    ]),
    getSubTotal() {
      let total = 0;
      for (var i = 0; i < this.invoice.items.length; i++) {
        var element = this.invoice.items[i];
        total += element.price * element.qty;
      }
      this.updateSubTotal(total);
      return total;
    },
    getTotalTaxes() {
      let s = 0;
      let taxable = this.getSubTotal();
      for (var i = 0; i < this.invoice.taxes.length; i++) {
        var tax = this.invoice.taxes[i];
        if (tax.type == "rate") {
          s += (tax.amount * taxable) / 100;
        } else {
          s += parseFloat(tax.amount);
        }
      }
      return s.toFixed(2);
    },
    getTotal() {
      let total =
        parseFloat(this.getSubTotal()) + parseFloat(this.getTotalTaxes());
      this.updateTotal(total.toFixed(2));
      return total.toFixed(2);
    }
  }
};
</script>

<style scoped>
</style>